import { Modal } from 'components';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  .ant-modal-content > div {
    border: 0;
    padding: 16px;
  }

  .ant-modal-content > .ant-modal-body {
    padding: 0px 16px 19px 16px;
  }
`;
export const StyledModalWidth = 352;
